<template>
  <div class="pages">
    <div class="main">
      <div class="nav_left" @click="goIndex">
        <div class="img"><img src="../assets/logo.png" alt="" /></div>
        <span>Home</span>
      </div>
      <div class="nav_right">
        <div v-for="(item, index) in lists" :key="index" class="text"
             :class="{ active: drNum == index }"
             @click="goRouter(item.path, index)">
          <span>{{ item.text }}</span>
          <span v-if="drNum == index"></span>
        </div>
        <!-- <p @click="goUser">{{ infoList.company }}</p> -->
        <p @click="goUser">My</p>
        <div class="userLogo" v-if="infoList&&infoList.logo" @click="goUser">
          <img :src="infoList.logo" alt="">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navTop',
  props: ['acIndex'],
  data () {
    return {
      lists: [
        { text: 'My order', path: '/order' },
        { text: 'My collection', path: '/cllection' },
        { text: 'Complaints and Suggestions', path: '/proposal' },
        { text: 'Common problem', path: '/problem' },
        { text: 'About us', path: '/about' },
        { text: 'Logout', path: '' }

      ],
      infoList: []
    };
  },
  computed: {
    drNum: {
      get () {
        return this.acIndex;
      },
      set (v) {
        this.a = v;
      }
    }
  },
  created () {
    this.infoList = JSON.parse(sessionStorage.getItem('infoList'));
  },
  methods: {
    goRouter (path, i) {
      this.drNum = i;
      if (i == 5) {
        this.$confirm('Do you want to exit?', 'Hint', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then((e) => {
          console.log(e)
          window.localStorage.clear()
          this.$router.push("/")
        }).catch(() => {

        });
        return
      }
      if (this.$route.path !== path) {
        this.$router.push({ path: path });
      }
    },
    goIndex () {
      this.$router.push({ path: '/index' });
    },
    goUser () {
      if (this.$route.path !== '/user') {
        this.$router.push({ path: '/user' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 浅蓝色科技风格变量
$blue-primary: #4fc3ff;
$blue-glow: rgba(79, 195, 255, 0.5);
$text-glow: 0 0 8px rgba(79, 195, 255, 0.5);

.userLogo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 20px;
  border: 1px solid $blue-primary;
  box-shadow: 0 0 10px $blue-glow;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 15px $blue-primary;
  }

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
}

.pages {
  height: 70px;
  margin-right: 20px;
  background: linear-gradient(90deg, #0a1a2a 0%, #1a3a5a 100%);
  border-bottom: 1px solid $blue-primary;
  box-shadow: 0 5px 20px $blue-glow;
  flex-shrink: 0;

  .main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1400px;
    height: 70px;
    box-sizing: border-box;

    .nav_left {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 5px 10px;
      border-radius: 10px;

      &:hover {
        background: rgba(79, 195, 255, 0.1);
        box-shadow: 0 0 20px $blue-glow;

        span {
          text-shadow: $text-glow;
        }
      }

      .img {
        padding: 3px;
        border: 2px solid transparent;
        box-sizing: border-box;
        border-image: linear-gradient(
                0deg,
                rgba(79, 195, 255, 0.9),
                rgba(79, 195, 255, 0.6),
                rgba(128, 216, 255, 0.9)
        ) 2 2;

        img {
          width: 90px;
          height: 45px;
          display: block;
          filter: drop-shadow(0 0 5px $blue-primary);
        }
      }

      span {
        padding: 0 8px;
        box-sizing: border-box;
        font-size: 18px;
        color: $blue-primary;
        font-weight: bold;
        text-shadow: 0 0 5px $blue-glow;
        transition: all 0.3s ease;
      }
    }

    .nav_right {
      display: flex;
      align-items: center;
      height: 70px;

      .text {
        height: 70px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        transition: all 0.3s ease;

        span:nth-child(1) {
          width: 100%;
          height: 70px;
          line-height: 70px;
          box-sizing: border-box;
          font-size: 16px;
          color: $blue-primary;
          font-weight: bold;
          margin-right: 20px;
          text-align: center;
          text-shadow: 0 0 5px $blue-glow;
          transition: all 0.3s ease;
        }

        &:hover span:nth-child(1) {
          text-shadow: $text-glow;
          color: lighten($blue-primary, 10%);
        }

        span:nth-child(2) {
          width: 100%;
          height: 3px;
          background: $blue-primary;
          border-radius: 4px;
          position: absolute;
          bottom: 0px;
          left: 0px;
          box-shadow: 0 0 15px $blue-primary, 0 0 30px $blue-primary;
          animation: glowPulse 2s infinite;
        }
      }

      p {
        font-size: 16px;
        color: $blue-primary;
        font-weight: bold;
        margin-right: 15px;
        cursor: pointer;
        padding: 6px 15px;
        border-radius: 20px;
        transition: all 0.3s ease;
        text-shadow: 0 0 5px $blue-glow;

        &:hover {
          background: rgba(79, 195, 255, 0.1);
          box-shadow: 0 0 20px $blue-glow;
          text-shadow: $text-glow;
          transform: translateY(-2px);
        }
      }
    }
  }
}

@keyframes glowPulse {
  0% {
    opacity: 0.5;
    box-shadow: 0 0 10px $blue-primary, 0 0 20px $blue-primary;
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 20px $blue-primary, 0 0 40px $blue-primary;
  }
  100% {
    opacity: 0.5;
    box-shadow: 0 0 10px $blue-primary, 0 0 20px $blue-primary;
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .main {
      .nav_right {
        .text {
          span:nth-child(1) {
            font-size: 14px;
            margin-right: 12px;
          }
        }
        p {
          font-size: 14px;
          margin-right: 8px;
          padding: 5px 12px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    height: auto;

    .main {
      flex-direction: column;
      padding: 8px;
      height: auto;

      .nav_left {
        margin-bottom: 8px;
        height: 50px;

        .img img {
          width: 80px;
          height: 40px;
        }

        span {
          font-size: 16px;
        }
      }

      .nav_right {
        height: auto;
        flex-wrap: wrap;
        justify-content: center;

        .text {
          height: 40px;

          span:nth-child(1) {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
            margin-right: 8px;
          }
        }

        p {
          margin: 3px 8px;
          padding: 4px 12px;
          font-size: 13px;
        }

        .userLogo {
          width: 25px;
          height: 25px;
          margin: 0 10px;
        }
      }
    }
  }
}
</style>